module.exports = __webpack_public_path__ + "img/ic_iphone.1124d4b6.svg";